import { render, staticRenderFns } from "./Factura_editar.vue?vue&type=template&id=7fb97f1d"
import script from "./Factura_editar.vue?vue&type=script&lang=js"
export * from "./Factura_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports